<template>
  <div class="card-pdf-itens-nota-fiscal">
    <div class="content-grupo">
      <div class="container-base">
        <div class="contador-paginas-nota" v-for="e in Math.ceil(itensNotasFiscaisArray.length / 3)" :key="e">
          <div class="template-pagina">
            <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
              <div class="titulo-conteudo-detalhes label-codigo-externo"> Nota Fiscal - {{`${serieNotaFiscal} / ${notaFiscalCodigoExterno}`}} </div>
              <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
            </div>

            <div class="imagem-template-rodape">
              <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ DiaHoje }}</div>
              <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-cabecalho">
            </div> 
          </div>
        </div>
      </div>

      <div class="content-informacoes-itens-nota-fiscal">
        <div class="borda-titulo-grupo">
          <div class="titulo-grupo"> ITENS DA NOTA FISCAL </div>
          <div class="borda-grupo"></div>
        </div>

        <div class="card-itens-nota-fiscal">
          <div class="item-nota-fiscal" v-for="(obj, index) in itensNotasFiscaisArray" :key="index">
            <div :class="`titulo-conteudo-detalhes titulo-numero-sequencia ${index != 0 && index % 3 === 0 ? 'espacamento-card' : ''}`"> Sequência {{ index + 1 }} </div>

            <div class="informacoes-item-nota-fiscal">
              <div class="item">
                <div class="titulo-conteudo-detalhes"> Item </div>
                <div class="label-conteudo">{{`${obj.codigoProduto} - ${obj.nomeItem}`}}</div>
              </div>

              <div class="unidade-medida">
                <div class="titulo-conteudo-detalhes"> Unid. Medida </div>
                <div class="label-conteudo">{{ obj.codigoUnidadeMedida }}</div>
              </div>

              <div class="peso">
                <div class="titulo-conteudo-detalhes"> Peso </div>
                <div class="label-conteudo">{{ obj.pesoUnitario }}</div>
              </div>

              <div class="quantidade">
                <div class="titulo-conteudo-detalhes"> Quantidade </div>
                <div class="label-conteudo">{{ obj.quantidadeItem }}</div>
              </div>

              <div class="porcentagem-desconto-mestre">
                <div class="titulo-conteudo-detalhes"> % Desc. Mestre </div>
                <div class="label-conteudo">{{ obj.percentualDescontoAdicionalMestre }}</div>
              </div>

              <div class="porcentagem-desconto">
                <div class="titulo-conteudo-detalhes"> % Desconto </div>
                <div class="label-conteudo">{{ obj.percentualDescontoAdicional }}</div>
              </div>

              <div class="desconto">
                <div class="titulo-conteudo-detalhes"> Desconto </div>
                <div class="label-conteudo">{{ obj.valorTotalDescontoAdicional }}</div>
              </div>

              <div class="montagem">
                <div class="titulo-conteudo-detalhes"> Montagem </div>
                <div class="label-conteudo">{{ obj.numeroOrdemDeCompra }}</div>
              </div>

              <div class="preco-pedido">
                <div class="titulo-conteudo-detalhes"> Preço Pedido </div>
                <div class="label-conteudo">{{ obj.precoUnitarioNotaFiscalFormatado }}</div>
              </div>

              <div class="preco-nota">
                <div class="titulo-conteudo-detalhes"> Preço Nota </div>
                <div class="label-conteudo">{{ obj.precoUnitarioNotaFiscalFormatado }}</div>
              </div>

              <div class="porcentagem-ipi">
                <div class="titulo-conteudo-detalhes"> % IPI </div>
                <div class="label-conteudo">{{ obj.percentualIPI }}%</div>
              </div>

              <div class="ipi">
                <div class="titulo-conteudo-detalhes"> IPI </div>
                <div class="label-conteudo">{{ obj.valorIPIFormatado }}</div>
              </div>

              <div class="valor-liquido">
                <div class="titulo-conteudo-detalhes"> Valor Líquido </div>
                <div class="label-conteudo">{{ obj.valorTotalLiquidoItemFormatado }}</div>
              </div>

              <div class="pedido-parcela">
                <div class="titulo-conteudo-detalhes"> Pedido/Parcela </div>
                <div class="label-conteudo">{{ obj.pedidoParcela }}</div>
              </div>
            </div>  

            <div class="html2pdf__page-break" v-if="(index + 1) % 3 === 0 && (index + 1) != itensNotasFiscaisArray.length"/> 
          </div>
        </div>
      </div>

      <div class="html2pdf__page-break"/>
    </div>
  </div>
</template>

<script>
import PDFItensNotaFiscal from './PDFItensNotaFiscal.js' 
export default PDFItensNotaFiscal
</script>

<style scoped>
.content-grupo {
  position: relative;
  height: 100%;
  width: 100%;
}

.container-base {
  position: absolute;
  width: 100%;
}

.contador-paginas-nota {
  position: relative;
  z-index: 2;
  left: 0;
}

.template-pagina {
  height: 70.125rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.imagem-template-cabecalho {
  display: flex;
  align-items: flex-start;
}
.imagem-template-rodape {
  position: relative;
  display: flex;
  align-items: flex-end;
}

.img-cabecalho, .img-rodape {
  width: 99.25%;
}

.espaco-codigo-externo-cabecalho {
  position: relative;
}

.label-codigo-externo {
  position: absolute;
  background-color: #FCB315;
  height: auto;
  width: auto;
  color: #4f2c19 !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.08rem;
  display: flex;
  align-items: center;
  margin: 1.4rem 0 0 3.5rem;
  top: 0;
  left: 0;
  z-index: 1000;
}

.content-informacoes-itens-nota-fiscal {
  height: 100%;
  width: 99.25%;
  padding: 5rem 2rem 3rem;
}

.conteudo-grupo {
  background-color: #F9F9F9;
  gap: 1rem 1.5rem;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
}

.data-rodape {
  color: #fff !important;
  font-size: 0.75rem !important;
  font-weight: 500;
  position: absolute;
  height: 100%;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  padding: 0.35rem 1.5rem 0.3rem 0;
  z-index: 2;
}

.content-informacoes-itens-nota-fiscal {
  height: 100%;
  width: 99.25%;
  padding: 5rem 2rem 3rem;
}

.titulo-grupo {
  width: 100%;
  color: #4f2c19;
  text-align: left;
  font-size: 1.1rem;
  font-family: "MontSerrat";
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.borda-titulo-grupo {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
}

.borda-grupo {
  width: 5rem;
  height: 3px;
  background-color: #FCB315;
}

.card-itens-nota-fiscal {
  display: flex;
  flex-direction: column;
  row-gap: 1.8rem;
  margin-top: 1.2rem;
}

.informacoes-item-nota-fiscal {
  background-color: #F9F9F9;
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 1.5rem;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
}

.item-nota-fiscal .titulo-conteudo-detalhes {
  color: #3f3f3f;
  font-size: 0.8rem;
  margin-top: 0.1rem;
}

.titulo-numero-sequencia {
  font-size: 0.85rem !important;
}

.item-nota-fiscal .label-conteudo {
  color: #8a8a8a !important;
  font-size: 0.9rem;
  font-family: 'MontSerrat';
  margin-top: 0.2rem;
  margin-bottom: 0;
}

.espacamento-card {
  padding-top: 4rem;
}
</style>
